/**
 * Controller for Map Controls directive
 * @param {object} $rootScope $rootScope
 * @param {object} $scope $scope
 * @returns {void}
 */
function ControlsController ($rootScope, $scope) {

  var vm = this;
  vm._sliderValue = vm._opacity = 100;

  /**
   * create a watch for the opacity value and set the value for map and datacapture in the Map Store
   * @param {object} Actions Map Actions
   * @returns {void}
   */
  function setOpacityWatch (Actions) {
    $scope.$watch('vm._opacity', function (val) {
      var opacities = {
        dcOpacity: val,
        mapOpacity: 100
      };

      if (val <= 99 && val >= 90) {
        opacities.mapOpacity = val - 20;
      } else if (val <= 89) {
        opacities.mapOpacity = val - 30;
      }

      Actions.SetOpacityValues.dispatch(opacities);

      $rootScope.$broadcast('opacityUpdated', {
        dcOpacity: val,
        mapOpacity: opacities.mapOpacity
      });
    });
  }

  this.show = true;
  this.showOpacity = false;

  this.init = function (map, Actions, Store) {
    this.map = map;
    this.Actions = Actions;
    this.Store = Store;
    setOpacityWatch(Actions);
  };

  this.zoomIn = function () {
    this.map.zoomIn();
  };

  this.zoomOut = function () {
    this.map.zoomOut();
  };

  this.showElevation = function () {
    return typeof vm.elevation !== 'undefined' && vm.elevation !== null;
  };
}

ControlsController.$inject = ['$rootScope', '$scope'];
module.exports = ControlsController;



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/controls/ControlsController.js